import CheckIcon from '@mui/icons-material/Check';
import CircleIcon from '@mui/icons-material/Circle';
import { Box } from 'shared/mui/Box';
import { ListItemAvatar, ListItemText } from 'shared/mui/List';
import { Typography } from 'shared/mui/Typography';
import { NotificationPopperListItem } from 'shared/widgets/Notification/NotificationPopper/NotificationPopperListItem/NotificationPopperListItem';
import { Notification, NotificationBodyOrderAdjustment } from 'types/embedded/notification';

import { IconButtonStyled, SmallRadioIcon } from './NotificationPopperListItemOrder.styled';
import { NotificationPopperListItemOrderSecondary } from './NotificationPopperListItemOrderSecondary';

type Props = {
  message: string;
  notification: Notification<NotificationBodyOrderAdjustment>;
  dataId: string;
};

export const NotificationPopperListItemOrder: React.FC<Props> = ({
  notification,
  message,
  dataId,
}) => {
  if (!('content' in notification.body)) {
    return <></>;
  }

  return (
    <NotificationPopperListItem data-id={dataId}>
      <ListItemAvatar>
        <IconButtonStyled>
          <CheckIcon htmlColor="#ffffff" />
        </IconButtonStyled>
      </ListItemAvatar>
      <ListItemText
        primary={
          <>
            <Typography component="span">{message}</Typography>
          </>
        }
        primaryTypographyProps={{ component: 'div', sx: { marginBottom: '8px' } }}
        secondary={
          <NotificationPopperListItemOrderSecondary
            createdAt={notification.body.content.createdAt}
            requestId={notification.body.content.requestId}
          />
        }
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ margin: 0 }}
      />
      <Box sx={{ marginTop: '2px' }}>
        {notification.isViewed ? (
          <SmallRadioIcon sx={{ fontSize: '8px' }} />
        ) : (
          <CircleIcon color="primary" sx={{ fontSize: '8px' }} />
        )}
      </Box>
    </NotificationPopperListItem>
  );
};
